module.exports = require("@swa-ui/shopping/src/CalendarStrip/CalendarStrip.module.scss");